import { SelectProps, Tag } from 'antd'
import { createStyles } from 'antd-style'
import { isNil } from 'lodash'

import { queryAnnouncementPageApi } from '@eastcoal/api/trade/announcementOperation/queryAnnouncementPage'
import { AnnouncementEntity } from '@eastcoal/api/trade/interface'

import { RemoteSelect } from '@eastcoal/common/components/RemoteSelect'

import { AnnouncementSelectProps } from './interface'

const useStyles = createStyles(({ token, prefixCls }) => ({
  select: {
    [`&.${prefixCls}-select-single`]: {
      height: 'auto',
      [`& .${prefixCls}-select-selection-item`]: {
        lineHeight: 'inherit'
      }
    }
  }
}))

const resolveOptions = (data: AnnouncementEntity[]) =>
  data.map(({ id, title, status, createdTime }) => {
    const descText = createdTime ? ` [${createdTime}]` : ''
    const statusText = !isNil(status) && Number(status) === 0 ? '未发布' : ''
    const labelText = (
      <div
        style={{
          wordBreak: 'revert-layer',
          whiteSpace: 'normal'
        }}
      >
        <span>
          {title}
          {descText}
        </span>
        {statusText && (
          <Tag
            color='red'
            style={{
              transform: 'scale(0.8)'
            }}
          >
            {statusText}
          </Tag>
        )}
      </div>
    )

    return {
      value: id,
      label: labelText
    }
  })

const getOptionValue = (value: AnnouncementEntity) => `${value.id}`

const optionRender: SelectProps['optionRender'] = ({ data }) => {
  return data.label
}

export const AnnouncementSelect = ({
  /* -------------------------------------------------------------------------- */
  /*                          AnnouncementSelect Props                          */
  /* -------------------------------------------------------------------------- */
  type,
  kindId,
  memberId,

  /* -------------------------------------------------------------------------- */
  /*                             RemoteSelect Props                             */
  /* -------------------------------------------------------------------------- */
  disabled,
  readyRequest,
  value,
  onChange
}: AnnouncementSelectProps) => {
  const { styles } = useStyles()

  return (
    <RemoteSelect
      allowClear
      api={queryAnnouncementPageApi}
      className={styles.select}
      disabled={disabled}
      getOptionValue={getOptionValue}
      mode={undefined}
      optionRender={optionRender}
      readyRequest={readyRequest}
      refreshDeps={[kindId, memberId]}
      resolveOptions={resolveOptions}
      value={value}
      requestParams={{
        type,
        kindId,
        memberId,
        orders: [
          {
            column: 'created_time',
            asc: false
          }
        ]
      }}
      onChange={onChange}
    />
  )
}
